interface StateType {
    titleAniSrc: string;
    innBackground: string;
    tab1: string;
    tab2: string;
    tab3: string;
    loopJson: string;
    routeJson: string;
}
type stateKey = keyof StateType;

interface PayloadType {
    key: stateKey;
    value: string;
}

export default {
    state: {
        tab1: '',
        tab2: '',
        tab3: '',
        titleAniSrc: '',
        innBackground: '',
        loopJson: '',
        routeJson: ''
    },
    mutations: {
        setBackgrondValue(state: StateType, playLoad: PayloadType) {
            const { key, value } = playLoad;
            if (key === 'titleAniSrc') {
                console.log('titleAniSrc', value.slice(0, 20));
            }
            if (state[key]) return;
            state[key] = value;
        }
    },

    namespaced: true
};
